// ---------------------------------------
// Miniplayer.js
// Player that plays a list of videos based on IDs provided by data-playlist attribute
// ---------------------------------------

import { play, pause } from '../services/players'
import Vue from 'vue'

import events from './miniplayer/events'
import dataslayer from './miniplayer/dataslayer'
import mobile from './miniplayer/mobile'
import playPauseButton from './miniplayer/components/playPauseButton'
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'

const MiniplayerVue = {
	defaultPlayerEmbedUrl: 'https://mediatn.cms.nova.cz', // Default embed player url fallback
	app: null,
	Init: function () {
		if (typeof window.PageData.playerEmbedUrl == 'undefined') {
			window.PageData.playerEmbedUrl = this.defaultPlayerEmbedUrl
		}

		// No miniplayer wrapper means no miniplayer JS
		if ($('.miniplayer-wrap').length === 0) {
			return
		}

		this.app = new Vue({
			el: '#miniplayer',
			template: `
            <div
                v-if="displayMiniplayer"
                id="miniplayer"
                class="miniplayer"
                :class="{'-fullscreen': isFullscreen, '-active': isActive, '-mobile-miniplayer-before-load': !isLoaded}"  
								@click=""     
                >

                <div class="c-player -mini">
                  <iframe
                      id="miniplayer-iframe"
                      src=""
                      :data-short="currentVideoId"
                      style="
                        position:absolute !important;
                        top:0 !important;
                        left:0 !important;
                        width:100% !important;
                        height:100% !important;
                        border:0 !important;
                      "
                      allow="autoplay; fullscreen; encrypted-media"
                      allowfullscreen=""
                  ></iframe>
                </div>
                
                <div class="miniplayer-description">
                  {{fullDescription}}
                </div>
                
                <playPauseButton
                    v-if="isMobileMiniplayer"
                    @click="events.handlers.playPauseButtonOnClick"
                    :isPlaying="isPlaying"
                >
                </playPauseButton>
                
                <div
                    v-if="isMobileMiniplayer"
                    class="miniplayer-off-button js-miniplayer-button"
                    @click="events.handlers.offButtonOnClick"
                >
                  <i class="icon icon-close"></i>
                </div>
              
                <div
                    v-if="isMobileMiniplayer"
                    class="miniplayer-on-button js-miniplayer-button"s
                    :class="{'-active': !isActive}"
                    @click="events.handlers.onButtonOnClick"
                >
                  <i class="icon icon-play"></i>
                </div>
            </div>
            `,
			components: {
				playPauseButton,
			},
			mixins: [events, dataslayer, mobile],
			data() {
				return {
					wrapper: $('.miniplayer-wrap'),
					playlist: $('.miniplayer-wrap').data('playlist').split(','),
					additionalQuery: $('.miniplayer-wrap').attr(
						'data-additional-query'
					),
					position: 0,
					playerId: null,
					shouldAutoplay: true,
					isMobileMiniplayer: false,
					displayMiniplayer: true,
					fullDescription: '',
					isPlaying: false,
					measurementData: null,
					wasPlayingBefore: false,
					isFullscreen: false,
					isFirstVideo: true,
					homepageTnLiveShort: null,
					homepageTnLiveId: null,
				}
			},
			computed: {
				currentVideoId() {
					return this.playlist[this.position]
				},
			},
			watch: {
				playerId() {
					window.playerId = this.playerId
				},
			},
			mounted() {
				if (this.wrapper.length < 1) {
					return
				}
				const savedPosition =
					localStorage.getItem('miniplayerPosition') || this.position
				const eyecatcher = $('.-eyecatcher')
				const hasMiniplayer = this.wrapper.length > 0
				const hasEyecatcher = eyecatcher.length > 0
				this.homepageTnLiveBox = $('.js-tnlive-homepage-box')

				if (hasEyecatcher || !this.shouldRenderMiniplayer()) {
					this.displayMiniplayer = false
				} else if (hasMiniplayer) {
					this.position = parseInt(savedPosition, 10)
					this.setValidPosition()
					this.events.create()

					window.onbeforeunload = () => {
						this.shiftPosition()
					}

					if (this.isMobileMiniplayer) {
						this.displayMiniplayer = false

						if (this.isFirstVideo) {
							this.setSource(this.currentVideoId, true)
							this.isFirstVideo = false
						}

						this.mobile.moveMiniplayerToBody()

						// Fancy effect
						const shouldBeHidden = localStorage.getItem(
							'thisItemChecksIfMobileMiniplayerShouldBeHidden'
						)
						const shouldBeHiddenUntilStamp = localStorage.getItem(
							'thisItemChecksUntilWhenMobileMiniplayerShouldBeHidden'
						)
						const nowStamp = Date.now()

						const sessionCheck =
							shouldBeHidden === 'true' &&
							shouldBeHiddenUntilStamp > nowStamp

						if (sessionCheck) {
							this.isActive = false
						} else {
							setTimeout(() => {
								// This might be confusing because it will play, but the reason is autoplay, not this function
								this.mobile.show(false)
							}, 100)
						}
					} else {
						this.checkViewportPlay()
					}
				}
			},
			destroyed() {
				this.shiftPosition()
			},

			methods: {
				getAdQuery() {
					let additionalQuery = this.additionalQuery

					if (typeof additionalQuery === 'undefined') {
						additionalQuery = ''
					}

					if (this.isMobileMiniplayer) {
						additionalQuery = additionalQuery.replace(
							'playerSize%miniplayer',
							'playerSize%3Dminiplayer-mobile'
						)
					}
					return additionalQuery
				},
				shouldRenderMiniplayer() {
					if (window.matchMedia('(max-width: 992px)').matches) {
						// if (Utils.isBlockedBySeznam()) {
						//   return false;
						// }
						// Default is enabled
						if (!window.PageData.mobile_mini_player) {
							this.isMobileMiniplayer = true
							$(document).trigger('miniplayer-init', [
								this.isMobileMiniplayer,
							])
							return this.isMobileMiniplayer
						}

						this.isMobileMiniplayer =
							!!window.PageData?.mobile_mini_player
								?.mobile_mini_player_should_render
						$(document).trigger('miniplayer-init', [
							this.isMobileMiniplayer,
						])
						return this.isMobileMiniplayer
					}
					return true
				},
				isPositionValid() {
					return this.playlist[this.position]
				},
				setValidPosition() {
					if (!this.isPositionValid()) {
						this.position = 0
					}

					localStorage.setItem('miniplayerPosition', this.position)
				},
				shiftPosition() {
					this.position += 1
					this.setValidPosition()
				},
				checkViewportPlay() {
					let options = {
						root: null,
						rootMargin: '0px',
						threshold: 0.25,
					}

					let intersectionCallback = (entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								this.shouldAutoplay = true
								if (this.playerId) {
									play(this.playerId)
								}
							} else {
								// uncheck this if autoplay interupts other streams
								// this.shouldAutoplay = false
								// if (this.playerId) {
								// 	pause(this.playerId)
								// }
							}
							this.displayMiniplayer = true
							if (this.isFirstVideo) {
								this.setSource(this.currentVideoId, true)
								this.isFirstVideo = false
							}
						})
					}

					const intersectionCallbackBlocker =
						(intersectionCallback) => (entries) => {
							if (Utils.IsCPlayerPlaying()) return
							intersectionCallback(entries)
						}

					let observer = new IntersectionObserver(
						intersectionCallbackBlocker(intersectionCallback),
						options
					)

					let target = document.querySelector('.miniplayer-wrap')
					observer.observe(target)
				},
				initHomepagePlayPause() {
					this.homepageTnLiveShort = this.GetShortId(
						this.homepageTnLiveBox.find('iframe').attr('src')
					)
					let options = {
						root: null,
						rootMargin: '0px',
						threshold: 0.25,
					}

					let intersectionCallback = (entries) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								play(this.homepageTnLiveId)
								pause(this.playerId)
							} else {
								play(this.playerId)
								pause(this.homepageTnLiveId)
							}
						})
					}

					let observer = new IntersectionObserver(
						intersectionCallback,
						options
					)

					let target = document.querySelector(
						'.js-tnlive-homepage-box'
					)
					observer.observe(target)
				},
				setSource(videoID, firstPlay) {
					let element = document.querySelector('#miniplayer-iframe')

					const params = {
						// autoplay: this.shouldAutoplay ? 1 : 0,
						autoplay: 1,
						mute_sound: 1,
						player_modifier: 'miniplayer',
					}

					// eslint-disable-next-line no-undef
					// if (
					// 	typeof sssp !== 'undefined' &&
					// 	sssp &&
					// 	sssp.displaySeznamAds()
					// ) {
					// 	params.da = 0
					// }

					let additionalQuery = this.getAdQuery()

					const iosIframeSwap = (originalEl) => {
						const newEl = document.createElement('iframe')
						newEl.id = 'miniplayer-iframe'
						newEl.setAttribute('data-short', videoID)
						newEl.setAttribute(
							'allow',
							'autoplay; fullscreen; encrypted-media'
						)
						newEl.setAttribute('allowfullscreen', '')
						newEl.style.position = 'absolute !important'
						newEl.style.top = '0 !important'
						newEl.style.left = '0 !important'
						newEl.style.width = '100% !important'
						newEl.style.height = '100% !important'
						newEl.style.border = '100% !important'
						newEl.setAttribute(
							'src',
							`${
								window.PageData.playerEmbedUrl
							}/embed/${videoID}?${Utils.EncodeGetParams(
								params
							)}&${additionalQuery}`
						)

						originalEl.remove()
						document.querySelector('.c-player.-mini').prepend(newEl)
					}

					const defaultIframeSourceSwap = (el, fp) => {
						if (fp) {
							el.setAttribute(
								'src',
								`${
									window.PageData?.playerEmbedUrl
								}/embed/${videoID}?${Utils.EncodeGetParams(
									params
								)}&${additionalQuery}`
							)
						} else {
							el.contentWindow.location.replace(
								`${
									window.PageData?.playerEmbedUrl
								}/embed/${videoID}?${Utils.EncodeGetParams(
									params
								)}&${additionalQuery}`
							)
						}

						el.classList.remove('kframe')
						el.setAttribute('data-short', videoID)
					}

					this.$nextTick(() => {
						if (Utils.IsIos()) {
							iosIframeSwap(element)
						} else {
							defaultIframeSourceSwap(element, firstPlay)
						}
					})
				},
				getShortId: function (url) {
					return url
						.split(window.PageData?.playerEmbedUrl + '/embed/')[1]
						.split('?')[0]
				},
				play() {
					this.isPlaying = true
					play(this.playerId)
				},
				pause() {
					this.isPlaying = false
					pause(this.playerId)
				},
			},
		})
	},
}

window.MiniplayerVue = MiniplayerVue
export default MiniplayerVue
